import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "addRoleModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-700px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Үүрэг нэмэх", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_9 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Хадгалах ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Болих ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearField && _ctx.clearField(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/web/media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form, {
            model: this.modalform,
            ref: "addrolemodalref",
            "label-width": "180px",
            "label-position": "left",
            size: "mini",
            rules: this.modalformrule
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Нэр:",
                prop: "name",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: this.modalform.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.modalform.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Тайлбар:",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "textarea",
                    modelValue: this.modalform.desc,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.modalform.desc) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_row, {
            type: "flex",
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                plain: "",
                size: "mini",
                class: "col-lg-3",
                loading: _ctx.buttonloader,
                onClick: _cache[3] || (_cache[3] = ($event: any) => {
                _ctx.saveRole();
                _ctx.formSubmit();
              })
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                ref: "hidemodalbutton",
                size: "mini",
                class: "col-lg-3",
                "data-bs-dismiss": "modal",
                onClick: _ctx.clearField
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}